'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EscrowRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EscrowRemote = exports.EscrowRemote = {
    completeEscrowDeposit: function completeEscrowDeposit(_ref) {
        var authToken = _ref.authToken,
            deployment = _ref.deployment,
            depositId = _ref.depositId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ apiPath: 'complete', authToken: authToken, deployment: deployment, path: '<ESCROW-API>' });
            request.send({ depositId: depositId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({
                    err: err,
                    reject: reject,
                    resolve: resolve,
                    response: response
                });
            });
        });
    },
    fetchEscrowAccount: function fetchEscrowAccount(_ref2) {
        var authToken = _ref2.authToken,
            bidderId = _ref2.bidderId,
            deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ apiPath: 'deposit/' + bidderId, authToken: authToken, deployment: deployment, path: '<ESCROW-API>' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({
                    err: err,
                    reject: reject,
                    resolve: resolve,
                    response: response,
                    transform: transformResponse
                });
            });
        });
    },
    releaseEscrowDeposit: function releaseEscrowDeposit(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            depositId = _ref3.depositId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ apiPath: 'release', authToken: authToken, deployment: deployment, path: '<ESCROW-API>' });
            request.send({ depositId: depositId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({
                    err: err,
                    reject: reject,
                    resolve: resolve,
                    response: response,
                    transform: transformResponse
                });
            });
        });
    }
};

var transformResponse = function transformResponse(_ref4) {
    var result = _ref4.result,
        success = _ref4.success,
        error = _ref4.error;

    var confirmed = (result || []).filter(function (x) {
        return x.status !== 'ReleaseConfirmed';
    });
    return {
        error: error,
        payload: confirmed.length > 0 ? confirmed[0] : null,
        success: success
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/escrow.js
// module id = 5Jny
// module chunks = 60